var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "md-layout" }, [
      _c("div", { staticClass: "md-layout-item " }, [
        _vm._m(0),
        _c("div", { staticClass: "custom-toolbar" }, [
          _c(
            "div",
            { staticClass: "custom-toolbar-start" },
            [
              _c("EntAgreementFilter", {
                on: { onChanged: _vm.entAgreementFilterChangedHandler },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "custom-toolbar-end" },
            [
              _vm.$root.isDesktop
                ? _c("SearchComponent", {
                    attrs: {
                      "search-filter": _vm.searchText,
                      placeholder: "Transaction Id, Company, Email",
                    },
                    on: { onSearch: _vm.searchComponentSearchHandler },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "md-layout" }, [
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
        },
        [
          _c(
            "md-card",
            [
              _c(
                "md-card-header",
                { staticClass: "md-card-header-icon md-card-header-blue" },
                [
                  _c(
                    "div",
                    { staticClass: "card-icon" },
                    [_c("md-icon", [_vm._v("payment")])],
                    1
                  ),
                ]
              ),
              _c(
                "md-card-content",
                { staticClass: "body-list" },
                [
                  !_vm.searchResults || !_vm.searchResults.length
                    ? [_c("p", [_vm._v("No result found.")])]
                    : [
                        _vm.selectedEntAgreementIds.length
                          ? _c(
                              "div",
                              {
                                class: [
                                  "bulk-section",
                                  _vm.topScrollPosition > 150 ? "sticky" : "",
                                ],
                              },
                              [
                                _c("div", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.selectedEntAgreementIds.length
                                      ) +
                                      " Enterprise Agreement" +
                                      _vm._s(
                                        _vm.selectedEntAgreementIds.length > 1
                                          ? "s"
                                          : ""
                                      ) +
                                      "\n                                selected.\n                            "
                                  ),
                                ]),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "md-primary btn-map-to-team",
                                        attrs: { title: "Map to a team" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.openMapping($event)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    Map to a team\n                                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "column" },
                          [
                            _c(
                              "md-table",
                              [
                                _c(
                                  "md-table-row",
                                  [
                                    _c(
                                      "md-table-head",
                                      [
                                        _c("md-checkbox", {
                                          staticClass:
                                            "checkbox-all button-gray",
                                          on: {
                                            change: function ($event) {
                                              return _vm.onSelectAll(
                                                _vm.isSelectAll
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.isSelectAll,
                                            callback: function ($$v) {
                                              _vm.isSelectAll = $$v
                                            },
                                            expression: "isSelectAll",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("md-table-head", [
                                      _vm._v("Client Name"),
                                    ]),
                                    _c("md-table-head", [
                                      _vm._v("Transaction Id"),
                                    ]),
                                    _c("md-table-head", [_vm._v("Status")]),
                                    _c("md-table-head", [_vm._v("Product")]),
                                    _c("md-table-head", [
                                      _vm._v("Agreement Date"),
                                    ]),
                                    _c("md-table-head", [
                                      _vm._v("Payment Date"),
                                    ]),
                                    _c("md-table-head", [_vm._v("Amount")]),
                                    _c("md-table-head", [
                                      _vm._v("Payment Source"),
                                    ]),
                                    _c("md-table-head", [_vm._v(" ")]),
                                  ],
                                  1
                                ),
                                _vm._l(
                                  _vm.searchResults,
                                  function (item, itemIndex) {
                                    return _c(
                                      "md-table-row",
                                      {
                                        key: "licenseDetails-" + itemIndex,
                                        staticClass: "ea",
                                      },
                                      [
                                        _c(
                                          "md-table-cell",
                                          [
                                            _c("md-checkbox", {
                                              staticClass: "ea-checkbox",
                                              attrs: {
                                                value:
                                                  item.enterpriseAgreementId,
                                              },
                                              model: {
                                                value:
                                                  _vm.selectedEntAgreementIds,
                                                callback: function ($$v) {
                                                  _vm.selectedEntAgreementIds =
                                                    $$v
                                                },
                                                expression:
                                                  "selectedEntAgreementIds",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("md-table-cell", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.clientName) +
                                              "\n                                        "
                                          ),
                                          _c("br"),
                                          _c("i", [
                                            _vm._v(
                                              _vm._s(item.clientCompanyName)
                                            ),
                                          ]),
                                        ]),
                                        _c("md-table-cell", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.transactionId) +
                                              "\n                                    "
                                          ),
                                        ]),
                                        _c("md-table-cell", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.status) +
                                              "\n                                    "
                                          ),
                                        ]),
                                        _c("md-table-cell", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.productName) +
                                              "\n                                    "
                                          ),
                                        ]),
                                        _c("md-table-cell", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm._f("dateFormat")(
                                                  item.agreementDate,
                                                  _vm.DATE_TYPES
                                                    .internationalDate
                                                )
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]),
                                        _c("md-table-cell", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm._f("dateFormat")(
                                                  item.paymentDate,
                                                  _vm.DATE_TYPES
                                                    .internationalDate
                                                )
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]),
                                        _c("md-table-cell", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                item.currency +
                                                  " " +
                                                  _vm.formatNumber(
                                                    item.amount,
                                                    2
                                                  )
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]),
                                        _c("md-table-cell", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.paymentSource) +
                                              "\n                                    "
                                          ),
                                        ]),
                                        _c(
                                          "md-table-cell",
                                          [
                                            _c(
                                              "md-button",
                                              {
                                                staticClass:
                                                  "md-info md-just-icon md-round md-primary",
                                                attrs: {
                                                  title: "View Details",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.showEAItems(item)
                                                  },
                                                },
                                              },
                                              [
                                                _c("md-icon", [
                                                  _vm._v("payment"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                ],
                2
              ),
              _vm.total
                ? _c(
                    "md-card-actions",
                    {
                      staticClass: "page-footer",
                      attrs: { "md-alignment": "space-between" },
                    },
                    [
                      _c("div", [
                        _vm.total === _vm.pagination.perPage
                          ? _c("p", { staticClass: "card-category" }, [
                              _vm._v(
                                "\n                            Page " +
                                  _vm._s(_vm.pagination.currentPage) +
                                  " of many\n                        "
                              ),
                            ])
                          : _c("p", { staticClass: "card-category" }, [
                              _vm._v(
                                "Page " +
                                  _vm._s(_vm.pagination.currentPage) +
                                  " of " +
                                  _vm._s(_vm.totalPages)
                              ),
                            ]),
                      ]),
                      _c("Pagination", {
                        staticClass: "pagination-no-border pagination-success",
                        attrs: {
                          "per-page": _vm.pagination.perPage,
                          total: _vm.total,
                          "enable-first-page-link": true,
                          "enable-last-page-link": true,
                        },
                        on: {
                          "change-page": function ($event) {
                            return _vm.handleChangePage(
                              $event,
                              _vm.pagination.perPage
                            )
                          },
                        },
                        model: {
                          value: _vm.pagination.currentPage,
                          callback: function ($$v) {
                            _vm.$set(_vm.pagination, "currentPage", $$v)
                          },
                          expression: "pagination.currentPage",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h3", [_vm._v("Unlinked Enterprise Agreements")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }